import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import { Provider } from 'react-redux'; // Import Provider from react-redux
import store from './Redux/store'; // Import your Redux store
import "./font/Museo.otf";
import "./font/museo-sans-rounded-300.ttf";
import "./font/museo-sans-rounded-700.ttf";
import "./font/museosansrounded-500-webfont.ttf";
import "./font/museosansrounded-900-webfont.ttf";
import "./font/OpenSans.ttf";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}> {/* Wrap the App with Provider */}
      <BrowserRouter> {/* Wrap the App with BrowserRouter */}
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

